import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import uuid from 'uuid';
import { ExpandIcon } from '../../components/Icons';
import BlockTypes from '../../types/BlockTypes';
import BlockActionTypes from '../../types/BlockActionTypes';
import { normalizeNode, shouldNotBeEmpty, shouldBeAtRoot, shouldMergeWithSimilarSiblings, shouldHaveChildrenOfType, shouldHaveParentOfType } from '../utils/NormalizationHelper';
import renderBlocks from '../utils/renderBlocks';
import makeBlockActionButton from '../utils/makeBlockActionButton';
import Gallery from './components/Gallery';
import './style.css';

function siblingsComparator(a, b) {
  if (a.type !== b.type) {
    return false;
  }

  return a.getIn(['nodes', 0, 'data', 'galleryId']) === b.getIn(['nodes', 0, 'data', 'galleryId']);
}

export var MAX_IMAGES = 3;
export default function ImageGalleryPlugin() {
  var store = {
    isDraggingNode: false
  };
  return [normalizeNode(BlockTypes.IMAGE_GALLERY, [shouldNotBeEmpty, shouldBeAtRoot, [shouldMergeWithSimilarSiblings, siblingsComparator], [shouldHaveChildrenOfType, BlockTypes.IMAGE], function shouldHaveMaxImages(node, editor) {
    var nodes = node.nodes.toArray();
    var sameGalleryId = !nodes.some(function (_ref, index) {
      var data = _ref.data;

      if (nodes[index + 1]) {
        return data.get('galleryId') !== nodes[index + 1].data.get('galleryId');
      }

      return false;
    });

    if (nodes.length > MAX_IMAGES && sameGalleryId) {
      var lastNode = node.nodes.last();
      editor.setNodeByKey(lastNode.key, {
        data: lastNode.data.set('galleryId', null)
      });
    }
  }]), normalizeNode(BlockTypes.IMAGE, [function shouldHaveGalleryId(node, editor) {
    if (!node.getIn(['data', 'galleryId'])) {
      editor.setNodeByKey(node.key, {
        data: node.data.set('galleryId', uuid())
      });
    }
  }, function shouldHaveSiblingsWithSameGalleryId(node, editor) {
    var parentNode = editor.value.document.getParent(node.key);
    var siblingNode = editor.value.document.getPreviousSibling(node.key) || editor.value.document.getNextSibling(node.key);

    if (parentNode && parentNode.type === BlockTypes.IMAGE_GALLERY && siblingNode && siblingNode.getIn(['data', 'galleryId']) !== node.getIn(['data', 'galleryId'])) {
      editor.unwrapNodeByKey(node.key);
    }
  }, [shouldHaveParentOfType, BlockTypes.IMAGE_GALLERY]]), _objectSpread({}, renderBlocks(_defineProperty({}, BlockTypes.IMAGE_GALLERY, function (props) {
    return React.createElement(Gallery, Object.assign({}, props, {
      store: store
    }));
  })), {
    onDrop: function onDrop(event, editor, next) {
      if (store.isDraggingNode) {
        event.preventDefault();
        return true;
      }

      return next();
    }
  }), makeBlockActionButton(BlockActionTypes.EXPAND, {
    index: 5,
    type: BlockActionTypes.ACTION,
    icon: ExpandIcon,
    label: 'Expand',
    canApply: function canApply(editor, store) {
      var node = store.getItem('node');
      return node.type === BlockTypes.IMAGE_GALLERY;
    },
    onClick: function onClick(editor, _ref2) {
      var nodes = _ref2.nodes;
      return editor.openLightbox(nodes.first());
    }
  })];
}